import {computed, Injectable, signal} from '@angular/core';

/** BRIEFD-7644: a photo joins its form value only once its upload finishes, so saving while
 *  uploads are in flight silently drops the unfinished ones. Save buttons read `busy`. */
@Injectable({
  providedIn: 'root'
})
export class PhotoUploadTrackerService {
  private readonly inFlight = signal(0);

  readonly busy = computed(() => this.inFlight() > 0);

  readonly busyMessage = $localize`:@@photos.upload-in-progress:Počakajte, da se fotografije naložijo.`;

  start(): void {
    this.inFlight.update((count) => count + 1);
  }

  finish(): void {
    this.inFlight.update((count) => Math.max(0, count - 1));
  }
}
